import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Save, ArrowUp, ArrowDown } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export function FaqAdmin({ content, refresh }) {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { setFaqs(Array.isArray(content?.faqs) ? content.faqs : []); }, [content]);

  const set = (i, k, v) => setFaqs((f) => f.map((x, idx) => (idx === i ? { ...x, [k]: v } : x)));
  const add = () => setFaqs((f) => [...f, { q: "", a: "" }]);
  const remove = (i) => setFaqs((f) => f.filter((_, idx) => idx !== i));
  const move = (i, d) => setFaqs((f) => {
    const j = i + d; if (j < 0 || j >= f.length) return f;
    const n = [...f]; [n[i], n[j]] = [n[j], n[i]]; return n;
  });
  const save = async () => {
    try { await api.put("/content", { faqs: faqs.filter((x) => x.q) }); refresh(); toast.success("FAQs saved & published"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="space-y-5" data-testid="faq-admin">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-serif-lux text-2xl">FAQs ({faqs.length})</h3>
          <p className="text-xs text-[#8a8a80]">Add questions &amp; answers shown on the public FAQs page.</p>
        </div>
        <div className="flex gap-2">
          <button onClick={add} className="btn-outline-dark !py-2 !px-4 text-sm inline-flex items-center" data-testid="faq-add"><Plus size={14} className="mr-1" /> Add</button>
          <button onClick={save} className="btn-gold !py-2 !px-5 text-sm inline-flex items-center" data-testid="faq-save"><Save size={14} className="mr-1.5" /> Save</button>
        </div>
      </div>
      {faqs.map((f, i) => (
        <div key={i} className="bg-white border border-[#E5E5DF] p-4 flex gap-3" data-testid={`faq-row-${i}`}>
          <div className="flex-1 space-y-2">
            <input className="input-lux !py-2" placeholder="Question" value={f.q || ""} onChange={(e) => set(i, "q", e.target.value)} data-testid={`faq-q-${i}`} />
            <textarea rows={3} className="input-lux !py-2 resize-none" placeholder="Answer" value={f.a || ""} onChange={(e) => set(i, "a", e.target.value)} data-testid={`faq-a-${i}`} />
          </div>
          <div className="flex flex-col gap-1">
            <button onClick={() => move(i, -1)} disabled={i === 0} className="p-1 text-[#8a8a80] hover:text-[#47562F] disabled:opacity-30" aria-label="Move up"><ArrowUp size={15} /></button>
            <button onClick={() => move(i, 1)} disabled={i === faqs.length - 1} className="p-1 text-[#8a8a80] hover:text-[#47562F] disabled:opacity-30" aria-label="Move down"><ArrowDown size={15} /></button>
            <button onClick={() => remove(i)} className="p-1 text-[#8a8a80] hover:text-red-600" aria-label="Delete" data-testid={`faq-del-${i}`}><Trash2 size={15} /></button>
          </div>
        </div>
      ))}
      {faqs.length === 0 && <p className="text-sm text-[#8a8a80]">No FAQs yet. Click “Add”, write a question &amp; answer, then “Save”.</p>}
    </div>
  );
}
